/**
 * Card de classificação de produtos
 */

import React from 'react';
import {
  Card,
  CardActionArea,
  Box,
  Typography,
  Avatar,
  Chip,
} from '@mui/material';
import { ChevronRight, Category } from '@mui/icons-material';
import { Classificacao } from '@types';
import { FormatUtil } from '@utils';
import theme from '@theme';

interface ClassificacaoCardProps {
  classificacao: Classificacao;
  onClick: (classificacao: Classificacao) => void;
}

export const ClassificacaoCard: React.FC<ClassificacaoCardProps> = ({
  classificacao,
  onClick,
}) => {
  const handleClick = () => {
    onClick(classificacao);
  };

  const getImageUrl = (filename: string): string => {
    if (!filename) return '';
    return FormatUtil.formatImageUrl(`${filename}`);
  };

  return (
    <Card
      sx={{
        height: '100%',
        transition: 'transform 0.2s, box-shadow 0.2s',
        '&:hover': {
          transform: 'translateY(-4px)',
          boxShadow: 4,
        },
      }}
    >
      <CardActionArea onClick={handleClick} sx={{ height: '100%' }}>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 2,
            p: 2,
          }}
        >
          {/* Imagem/Avatar */}
          <Avatar
            sx={{
              width: 64,
              height: 64,
              bgcolor: theme.palette.elite.contrastText,
              color: 'primary.main',
            }}
            src={getImageUrl(classificacao.imagem)}
          >
            <Category fontSize="large" />
          </Avatar>

          {/* Conteúdo */}
          <Box sx={{ flexGrow: 1, minWidth: 0 }}>
            <Typography variant="h6" fontWeight={600} noWrap>
              {classificacao.nome}
            </Typography>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: 0.5 }}>
              <Chip
                label={`${classificacao.total} produtos`}
                size="small"
                color="primary"
                variant="outlined"
              />
            </Box>
          </Box>

          {/* Seta */}
          <ChevronRight sx={{ color: 'text.secondary' }} />
        </Box>
      </CardActionArea>
    </Card>
  );
};